import React, { useEffect, useState, useCallback } from "react";
import Layout from "containers/LayoutV2";
import configsRole from "utils/configsRole";
import "react-dropdown/style.css";
import { TableDanhSach } from "./TableDanhSach";
import SearchBarDesktop from "./SearchBarDesktop";
import QuanLyMauHopDongApi from "service/QuanTriHeThong/QuanLyMauHopDong/QuanLyMauHopDongApi";
import StoreApi from "service/phanQuyenApi";

export const QuanLyMauHopDong = () => {
  const initPhanQuyen = {
    quanlymauhopdong: false,
    themmoi: false,
    sua: false,
    xoa: false,
    xem: false,
  };
  const [phanQuyen, setPhanQuyen] = useState(initPhanQuyen);
  const [loading, setLoading] = useState(true);
  const initialDataSearch = {
    sContractName: "",
    isKeyword: true,
    PageIndex: 1,
    PageSize: 25,
  };
  const [dataSearch, setDataSearch] = useState(initialDataSearch);
  const [listDanhSach, setListDanhSach] = useState({
    List: [],
    iTotal: 0,
    PageSize: 20,
    PageIndex: 1,
  });
  const [isLoadingList, setIsLoadingList] = useState(false);

  const LoadPhanQuyen = () => {
    setLoading(true);
    StoreApi.getAllQuyen()
      .then((response) => {
        if (response.status === 200) {
          const getRole = (code) =>
            response.data.some(
              (e) => e.ModuleCode?.toUpperCase() === code.toUpperCase()
            );
          setPhanQuyen({
            quanlymauhopdong: getRole(configsRole.sRole.quanlymauhopdong),
            themmoi: getRole(configsRole.sRole.quanlymauhopdong_themmoi),
            sua: getRole(configsRole.sRole.quanlymauhopdong_sua),
            xem: getRole(configsRole.sRole.quanlymauhopdong_xem),
            xoa: getRole(configsRole.sRole.quanlymauhopdong_xoa),
          });
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    document.title = "Quản lý mẫu hợp đồng | Phần mềm quản lý cầm đồ Morman";
    LoadPhanQuyen();
  }, []);

  const handleSearchContract = useCallback(
    (search = dataSearch) => {
      const fullSearch = { ...initialDataSearch, ...search };
      setIsLoadingList(true);
      QuanLyMauHopDongApi.getList(fullSearch)
        .then((res) => {
          if (res && res.status === 200) {
            setListDanhSach({
              List: res.data.List || [],
              iTotal: res.data.iTotal || 0,
              PageSize: fullSearch.PageSize || 20,
              PageIndex: fullSearch.PageIndex || 1,
            });
          } else {
            setListDanhSach({
              List: [],
              iTotal: 0,
              PageSize: fullSearch.PageSize || 20,
              PageIndex: fullSearch.PageIndex || 1,
            });
          }
        })
        .catch(() => {
          setListDanhSach({
            List: [],
            iTotal: 0,
            PageSize: fullSearch.PageSize || 20,
            PageIndex: fullSearch.PageIndex || 1,
          });
        })
        .finally(() => setIsLoadingList(false));
    },
    [dataSearch]
  );

  const handleReloadList = () => {
    handleSearchContract();
  };
  useEffect(() => {
    if (!loading && phanQuyen.quanlymauhopdong) {
      handleSearchContract({ ...dataSearch, PageIndex: 1 });
    }
  }, [loading, phanQuyen.quanlymauhopdong]);

  // if (loading) return null;

  return (
    <Layout>
      {phanQuyen.quanlymauhopdong === true ? (
        <div id="form-repeater" className="p-1">
          <div className="row header justify-content-start ml-1">
            <img
              src="/app-assets/images/icon-cau-hinh.png"
              alt="Mẫu hợp đồng"
            />
            <h1 className="text-info-home">Quản lý mẫu hợp đồng</h1>
          </div>
          <div className="p-1">
            <SearchBarDesktop
              dataSearch={dataSearch}
              setDataSearch={setDataSearch}
              onSearch={handleSearchContract}
            />
            <TableDanhSach
              phanQuyen={phanQuyen}
              listDanhSach={listDanhSach}
              isLoading={isLoadingList}
              dataSearch={dataSearch}
              setDataSearch={setDataSearch}
              onSearch={handleSearchContract}
              onReload={handleReloadList}
            />
          </div>
        </div>
      ) : (
        <div id="form-repeater" className="p-1">
          <div className="d-flex align-items-center">
            <img
              src="/app-assets/images/logo-phieuthuchi-v2.png"
              alt="Mẫu hợp đồng"
              style={{
                width: "38px",
                height: "33px",
                borderRadius: "70%",
              }}
            />
            <h1 className="text-info-home mb-0 ms-2 fw-bold">
              Quản lý mẫu hợp đồng
            </h1>
          </div>
          <span
            style={{
              textAlign: "center",
              color: "red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Bạn không có quyền truy cập chức năng này.
          </span>
        </div>
      )}
    </Layout>
  );
};

export default QuanLyMauHopDong;
